import React, { useContext, useEffect, FunctionComponent } from 'react';

import { deleteBoard } from '@api/v4/boards';
import { AllBoardsViewContext, AllBoardsContextTypes } from '@components/boards/all_boards_view';
import { BoardResponseObject } from '@api/v4/boards/boardsTypes';
import renderModal from '@components/show_page/modals/renderModal';
import { CloseButton, DangerButton, TertiaryButton } from '@components/library/button/index';

// reflect success or error message
// TODO add notify
interface DeleteBoardHandlerParams {
  boardId: string;
  boards: BoardResponseObject[];
  setBoards: AllBoardsContextTypes['setBoards'];
  closeModal: () => void;
}
const deleteBoardHandler = async (options: DeleteBoardHandlerParams): Promise<void> => {
  const { boardId, boards, setBoards, closeModal } = options;
  try {
    // reponse is created board
    await deleteBoard({ boardId });
    // remove deleted board, and update boards state
    const trimmedBoards = boards.filter((board) => board.id !== boardId);
    Notify.create({ title: t("Board successfully deleted"), type: "success" });
    setBoards(trimmedBoards);
  } catch (error) {
    console.log(error);
    Notify.create({ title: t("Something went wrong, could not delete board."), type: "error" });
    closeModal();
  }
};

interface DeleteBoardModalProps {
  boardName: string;
  boardId: string;
  closeModal: () => void;
}
const DeleteBoardModal: FunctionComponent<DeleteBoardModalProps> = (options) => {
  const { boardName, boardId, closeModal } = options;
  const AllBoardsViewState = useContext(AllBoardsViewContext);
  useEffect(() => (closeModal), []); // fire closeModal when unmounting

  return (
    <div className="modal-content-wrapper delete-board-modal">
      <div className="modal-content-wrapper__header">
        <h3 className="modal-title">
          <span className="bff-trash icon" aria-hidden="true" />
          {t("Delete")} "{boardName}" {t("Board")}
        </h3>
        <CloseButton onClick={closeModal} />
      </div>
      <div className="modal-content-wrapper__body">
        <p>{t("This action will not delete assets from your Brandfolder(s).")}</p>
        <div className="button-container">
          <TertiaryButton
            className="t-close-modal"
            onClick={closeModal}
            size="small"
          >
            {t("Cancel")}
          </TertiaryButton>
          <DangerButton
            className="t-confirm-modal"
            onClick={(): Promise<void> => deleteBoardHandler({ boardId, boards: AllBoardsViewState.boards, setBoards: AllBoardsViewState.setBoards, closeModal })}
            size="small"
          >
            {t("Delete")}
          </DangerButton>
        </div>
      </div>
    </div>
  );
};

const ModalComponent = renderModal(DeleteBoardModal, 'DeleteBoardModal');
export default ModalComponent;
